import { Box, BoxProps } from '@mui/material'

import BackgroundXl from 'assets/images/background_1_xl.png'
import BackgroundLg from 'assets/images/background_1_lg.png'
import BackgroundMd from 'assets/images/background_1_md.png'
import BackgroundSm from 'assets/images/background_1_sm.png'

import { Theme, styled } from '@mui/material/styles'

export const Background1 = styled(Box)<BoxProps>((props) => {
  const theme: Theme = props.theme as unknown as Theme
  return {
    width: '100%',
    backgroundImage: `url(${BackgroundXl})`,
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    [theme.breakpoints.down('lg')]: {
      backgroundImage: `url(${BackgroundLg})`,
    },
    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${BackgroundMd})`,
    },
    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${BackgroundSm})`,
    },
  }
})
